export { default } from "./StudentList";

